var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"inline-block"},attrs:{"data-ad-client":"ca-pub-5310971739125617","data-ad-slot":_vm.adSlot,"data-ad-format":"auto","data-full-width-responsive":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }